module.exports = __webpack_public_path__ + "assets/img/8.92d4bc86.jpg";